export default __webpack_public_path__ + "static/media/resendMailB.5da0f456.svg";